<div class="content">
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 common_title">
          <h2>ADD - SPECIES MANAGEMENT</h2>
          <a (click)="backnavigate()" class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
            Back
          </a>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 common_title">
          <p>Create Species record</p>
        </div>
      </div>

      <form [formGroup]="registerForm" class="row">
        <!--loader start-->
        <div class="loading-div" *ngIf="isLoading">
          <div class="loading-bar">
            <div class="lds-roller">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            <p class="mt-3">Processing data. Please wait..</p>
          </div>
        </div>
        <!--loader end-->
        <div class="col-lg-4 col-md-6 col-sm-6 ">
          <div class="form-group multiple">
            <label for="Farm Name" class="farmmulti">Farm Name</label>
            <select multiple="multiple" name="farmname" id="farmname" class="form-control">
              <option *ngFor='let getfarms of getfarmsListData' [value]="getfarms.tnfr_id">{{getfarms.tnfr_name}}
              </option>
            </select>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="form-group">
            <label class="spce" for="Species Name">Species Name</label>
            <input type="text" id="speciesName" value="Cow" formControlName="speciesName" class="form-control"
              [ngClass]="{ 'is-invalid': submitted && f.speciesName.errors }" />
            <div *ngIf="submitted && f.speciesName.errors" class="invalid-feedback">
              <div class="selectvalidate" *ngIf="f.speciesName.errors.required">Species Name must be filled out</div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="form-group">
            <label class="spce" for="Species Name">Species ID</label>
            <input type="text" id="speciesid" value="Cow" formControlName="speciesid" class="form-control"
              [ngClass]="{ 'is-invalid': submitted && f.speciesid.errors }" />
            <div *ngIf="submitted && f.speciesid.errors" class="invalid-feedback">
              <div class="selectvalidate" *ngIf="f.speciesid.errors.required">Species ID must be filled out</div>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-6 col-sm-6 status" style="top: -28px;">
          <div class="form-group">
            <label for="Status"><span class="dec">Status</span></label>
            <select id="status" class="selectpicker form-control addspeciesfak" required
              (change)="statusupdate()"><!--formControlName="status" [ngClass]="{ 'is-invalid': submitted && f.status.errors }"-->
              <option value="1">Active</option>
              <option value="0">Inactive</option>
            </select>
            <!-- <div *ngIf="submitted && f.status.errors">
        <div class="selectvalidate" *ngIf="f.status.errors.required">Species Status is required</div>
      </div>-->
          </div>

        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 text-center" style="top:-26px;
        left: 267px;">

            <div class="col-lg-2 col-md-2 col-sm-2 text-center">
            </div>
            <div class="col-lg-8 col-md-8 col-sm-8 text-center">

              <table class="table" style="color: white;border:none; font-family: 'Montserrat', sans-serif;">
                <thead>
                  <tr>
                    <th scope="col"></th>
                    <th scope="col" class="sizered">Name</th>
                    <th scope="col" class="sizered">Lower limit (Days)</th>
                    <th scope="col" class="sizered">Upper limit (Days)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th><span class="sizered">Age Group 1</span></th>
                    <td>
                      <input type="text" name="agegroupName1" id="agegroupName1" value="" class="form-control">

                    </td>
                    <td>
                      <input type="text" name="lowerlimit1" id="lowerlimit1" value="0" class="form-control" readonly>

                    </td>
                    <td>
                      <input type="text" name="upperlimit1" id="upperlimit1" (keyup)="getinputvalue($event)" value=""
                        class="form-control">
                    </td>
                  </tr>
                  <tr>
                    <th><span class="sizered">Age Group 2</span></th>
                    <td>

                      <input type="text" name="agegroupName2" id="agegroupName2" class="form-control">
                    </td>
                    <td>
                      <input type="text" name="lowerlimit2" id="lowerlimit2" [value]="upperlimit" class="form-control"
                        readonly>

                    </td>
                    <td>
                      <input type="text" name="upperlimit2" id="upperlimit2" (keyup)="getinputvalue2($event)" value=""
                        class="form-control">

                    </td>
                  </tr>
                  <tr>
                    <th><span class="sizered">Age Group 3</span></th>
                    <td>
                      <input type="text" name="agegroupName3" id="agegroupName3" value="" class="form-control">

                    </td>
                    <td>
                      <input type="text" name="lowerlimit3" id="lowerlimit3" [value]="upperlimit1" class="form-control"
                        readonly>

                    </td>
                    <td>
                      <input type="text" name="upperlimit3" id="upperlimit3" (keyup)="getinputvalue3($event)" value=""
                        class="form-control">
                    </td>
                    <td>
                      <a class="btn btn-primary decrese" [class.disablebutton]="isDisabled"
                        (click)="createagegrouprow()" role="button">Add Row</a>
                    </td>
                  </tr>

                  <ng-template [ngIf]="isDone==1">
                    <tr>
                      <th><span class="sizered">Age Group 4</span></th>
                      <td>
                        <input type="text" name="agegroupName4" id="agegroupName4" value="" class="form-control">

                      </td>
                      <td>
                        <input type="text" name="lowerlimit4" id="lowerlimit4" [value]="upperlimit2"
                          class="form-control" readonly>

                      </td>
                      <td>
                        <input type="text" name="upperlimit4" id="upperlimit4" value="" class="form-control">
                      </td>
                    </tr>
                  </ng-template>
              </table>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 text-center">
            </div>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 text-center">
          <button (click)="onSubmit()" class="btn btn-fill btn-primary mb-3">Submit<div class="ripple-container"></div>
            </button>
          <button (click)="backnavigate()" class="btn btn-fill btn-default">Cancel<div class="ripple-container"></div>
            </button>
        </div>
      </form>
    </div>
  </div>
</div>
<!--MODEL POPUP------------------------------------------------------------------>

<!-- The Modal -->
<div class="modal" id="myModal">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Age group</h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        <form class="row">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="form-group">
              <label for="Species Name" class="puptext">Age Group Name</label>
              <input type="text" name="Name" id="Name" value="" class="form-control">
            </div>
          </div>

          <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="form-group">
              <label for="Species Name" class="puptext">Time Range(In days)</label>
              <input type="text" name="timerange" id="timerange" value="" class="form-control">
            </div>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="form-group">
              <label for="Status" class="puptext">Status</label>
              <select id="statusage" class="selectpicker form-control">
                <option class="green" value="1">Active</option>
                <option class="red" value="0">InActive</option>
              </select>
            </div>
          </div>

          <div class="col-lg-12 col-md-12 col-sm-12 text-center">
            <button data-dismiss="modal" (click)=modelpopupgetdata() type="submit"
              class="btn btn-fill btn-primary mb-3">Submit<div class="ripple-container"></div></button>
            <button data-dismiss="modal" (click)="backnavigate()" class="btn btn-fill btn-default">Cancel<div
                class="ripple-container"></div></button>
          </div>
        </form>
      </div>

    </div>
  </div>
</div>
